
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {
		ano: new Date().getFullYear()
	},
	lista: [],
	listaMotorista: [],
	listaCavalo: [],
	listaCarreta: [],
	listaTipo: [],
	listaEstado: [],
	listaGestaoVeiculo: [],
	listaGestaoMotorista: [],
	listaMotoristaVencimento: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'GESTAO_VM_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'GESTAO_VM_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'GESTAO_VM_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'GESTAO_VM_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.map(item => ({
					id: item.id,
					valor: item.nome
				}))
			};
		
		case 'GESTAO_VM_MOTORISTA_SELECT_LISTADO':
            return {
				...state,
				listaMotorista: action.payload.data
			};

		case 'GESTAO_VM_PLACA_SELECT_LISTADO':
            return {
				...state,
				listaCavalo: action.payload.data.filter(item => item.tracao),
				listaCarreta: action.payload.data.filter(item => !item.tracao)
			};

		case 'GESTAO_VM_GESTAO_VEICULO_LISTADO':
            return {
				...state,
				listaGestaoVeiculo: action.payload.data
			};

		case 'GESTAO_VM_GESTAO_MOTORISTA_LISTADO':
            return {
				...state,
				listaGestaoMotorista: action.payload.data
			};

		case 'GESTAO_VM_MOTORISTA_VENCIMENTO_LISTADO':
            return {
				...state,
				listaMotoristaVencimento: action.payload.data
			};

        default:
            return state;
    }
}
